// Who /assistencies_multiple has already been asked about on this page, for
// how many events. Choosing the same people in another order, or fewer of
// them, asks nothing again; on 2026-10-22 sarri's page sent the same 1.253 ids
// dozens of times in a slightly different order.
export const createAssistenciesRequests = () => {
    let eventsCount = null;
    const asked = new Set();

    return {
        // The ids still to ask for, sorted, now counted as asked
        take(users, eventsLength) {
            if (eventsLength !== eventsCount) {
                eventsCount = eventsLength;
                asked.clear();
            }
            const missing = [...new Set(users.map(String))]
                .filter(user => !asked.has(user))
                .sort((a, b) => a - b || a.localeCompare(b));
            missing.forEach(user => asked.add(user));
            return missing;
        },
        // A failed request: these may be asked for again
        forget(users) {
            users.forEach(user => asked.delete(String(user)));
        },
    };
};

// The same people in any order give the same key
export const usersKey = users => [...new Set(users.map(String))]
    .sort((a, b) => a - b || a.localeCompare(b))
    .join(',');
